module.exports = __webpack_public_path__ + "img/9_pc.1acdbe8b.gif";